import React from "react";
import { Button, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import FormHeaderWrapper from "../forms/FormHeader.style";
import RestrictedComponent from "../util/RestrictedComponent";

const { Title } = Typography;

const TableHeader = ({
  title,
  hidePrimary,
  resource,
  handleAdd,
  editingKey,
}) => (
  <FormHeaderWrapper>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Title level={5} style={{ margin: 0 }}>
        {title}
      </Title>
      {!hidePrimary && (
        <RestrictedComponent
          resource={resource || "organization.settings"}
          action={"editor"}
          comp={null}
        >
          <Button
            type="primary"
            onClick={handleAdd}
            disabled={editingKey !== ""}
          >
            <FormattedMessage id={`app.settings.system_tables.addRecord`} />
          </Button>
        </RestrictedComponent>
      )}
    </div>
  </FormHeaderWrapper>
);

export default TableHeader;
